import "./ShowPackage.css";

import { Breadcrumb, Button, message, Tag } from "antd";
import { BiEdit } from "react-icons/bi";
import { BsTrash } from "react-icons/bs";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { useAppSelector } from "../../../_lib/_store";
import { deletePackage } from "../../../_lib/_store/services/packageService";

export const ShowPackagePage = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const { isLoading } = useAppSelector((state) => state.package);

  const navigate = useNavigate();
  const { state } = useLocation();

  const packageObj = state?.package;

  const handleDelete = async () => {
    const res = await deletePackage(messageApi, packageObj?.id);
    if (res) {
      navigate("/package");
    }
  };

  return (
    <>
      {contextHolder}
      <div className="createPackage">
        <Breadcrumb
          items={[
            {
              title: <Link to="/dashboard">Dashboard</Link>,
            },
            {
              title: <Link to="/package">Package</Link>,
            },
            {
              title: "Show",
            },
          ]}
        />

        <div className="titleHeader">
          <h2 className="title">Show</h2>
          <div className="actionButton">
            <Button
              icon={<BiEdit />}
              size="large"
              onClick={() =>
                navigate(`/package/edit`, {
                  state: { package: state?.package },
                })
              }
            >
              Edit
            </Button>
            <Button
              icon={<BsTrash />}
              size="large"
              onClick={handleDelete}
              loading={isLoading}
            >
              Delete
            </Button>
          </div>
        </div>

        <div className="form">
          <div className="row">
            <p className="label">Name</p>
            <p className="value">{packageObj?.name}</p>
          </div>
          <div className="row">
            <p className="label">Id</p>
            <p className="value">{packageObj?.id}</p>
          </div>
          <div className="row">
            <p className="label">Description</p>
            <p className="value">{packageObj?.description}</p>
          </div>
          <div className="row">
            <p className="label">Tags</p>
            <div className="tagBox">
              {packageObj?.tags?.map((v: string, i: number) => {
                return (
                  <div key={i} className="row">
                    <p className="label">{i + 1}</p>
                    <p className="value">{v}</p>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="row">
            <p className="label">Package Type</p>
            <p className="value">
              <Tag>{packageObj?.packageType}</Tag>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};
